"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreComboChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var BaseChart_1 = require("../_base/BaseChart");
var CoreComboChart = /** @class */ (function (_super) {
    tslib_1.__extends(CoreComboChart, _super);
    function CoreComboChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreComboChart.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "combo" }, this.props));
    };
    return CoreComboChart;
}(react_1.default.PureComponent));
exports.CoreComboChart = CoreComboChart;
//# sourceMappingURL=CoreComboChart.js.map